import { useContext } from 'react';
import { Chart } from 'chart.js';
import DayChart from './DayChart/DayChart';
import CapacityChart from './CapacityChart/CapacityChart';
import AnnualGenerationChart from './AnnualGenerationChart/AnnualGenerationChart';
import CarbonCostChart from './CarbonCostChart/CarbonCostChart';
import SimpleVersion from './SimpleVersion/SimpleVersion';
import styles from './MECharts.module.css';
import { AllInputDataContext, CalculatedDataContext } from '../../config';
import ReserveChart from './ReserveChart/ReserveChart';

// Set Chart.js global text/grid defaults for the dark navy background
Chart.defaults.color = 'rgba(255,255,255,0.85)';
Chart.defaults.borderColor = 'rgba(255,255,255,0.12)';

type Props = {
  version: string;
};

export default function MECharts({ version }: Props) {
  const { optionsData } = useContext(AllInputDataContext);

  const { reserveRemaining } = useContext(CalculatedDataContext);

  const blackoutPercentage = () => {
    if (reserveRemaining >= 0) {
      return 0;
    } else {
      const blackoutPercentage = 1 - 1 / -reserveRemaining;

      if (blackoutPercentage < 1) {
        return blackoutPercentage;
      } else {
        return 1;
      }
    }
  };

  return (
    <>
      <div
        id='suttyid'
        className={styles.chartWrapper}
        style={{ backgroundColor: 'rgba(0,0,0,' + blackoutPercentage() + ')' }}
      >
        {version === 'educational' ? (
          <SimpleVersion version={version} />
        ) : (
          <div className={styles.chartsContainer}>
            {Array(optionsData.noOfDayTypes)
              .fill(undefined)
              .map((a, index) => {
                //a is a placeholder
                return <DayChart dayTypeNumber={index} key={`${index}`} />;
              })}

            <CapacityChart />
            <AnnualGenerationChart />
            <ReserveChart />
            <CarbonCostChart metric="carbon" />
            <CarbonCostChart metric="cost" />
          </div>
        )}
      </div>
    </>
  );
}
